import {useEffect, useEffectEvent} from 'react'

const focusSymbolPaneEvent = 'react_blob_view_focus_symbol_pane'

declare global {
  interface WindowEventMap {
    [focusSymbolPaneEvent]: CustomEvent<{focusSymbolSearch: boolean}>
  }
}

export function useFocusSymbolPane(callback: (focusSymbolSearch: boolean) => void) {
  const eventHandler = useEffectEvent(callback)

  useEffect(() => {
    const handleScrollEvent = (
      e: CustomEvent<{
        focusSymbolSearch: boolean
      }>,
    ) => {
      eventHandler((e as CustomEvent).detail?.focusSymbolSearch || false)
    }
    window.addEventListener(focusSymbolPaneEvent, handleScrollEvent)
    return () => {
      window.removeEventListener(focusSymbolPaneEvent, handleScrollEvent)
    }
  }, [])
}

export function focusSymbolPane() {
  window.dispatchEvent(new CustomEvent(focusSymbolPaneEvent, {detail: {focusSymbolSearch: false}}))
}

export function focusSymbolSearch() {
  window.dispatchEvent(new CustomEvent(focusSymbolPaneEvent, {detail: {focusSymbolSearch: true}}))
}
